export default __webpack_public_path__ + "static/media/abstract2.b069e1a9.jpg";